// console.log('Gift manager loaded (v6 - Quantity Fix):', window.location.pathname);

// (function () {

//   const TIERS = [
//     { min: 400000, max: 600000, tier: 'body_mist', popup: 'body-mist-gifts' },
//     { min: 600000, max: 800000, tier: '30ml', popup: 'gift-30ml' },
//     { min: 800000, max: 1200000, tier: '50ml', popup: 'gift-50ml' },
//     { min: 1200000, max: Infinity, tier: '100ml', popup: 'gift-100ml' }
//   ];

//   const APPAREL_TAGS = ['Free-apparel-gift', 'naturals'];
//   const EXCLUDED_TAGS = [''];

//   let running = false;
//   let lastTier = null;
//   let popupTimeout = null;
//   let uiObserver = null;

//   // =====================================================
//   // BUY IT NOW INTERCEPTOR
//   // =====================================================

//   // ✅ Selected quantity lena
//   function getSelectedQuantity() {
//     const qtyInput = document.querySelector(
//       'input[name="quantity"], .quantity__input, [data-quantity-input], #quantity, .qty__input, [data-cart-quantity]'
//     );
//     const qty = parseInt(qtyInput?.value || '1', 10);
//     return isNaN(qty) || qty < 1 ? 1 : qty;
//   }

//   // ✅ Price × Quantity = total
//   async function getCurrentProductPrice() {
//     try {
//       const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
//       if (!handle) return 0;

//       const res = await fetch(`/products/${handle}.js`);
//       const product = await res.json();

//       const selectedVariantId = getSelectedVariantId();
//       let unitPrice = 0;

//       if (selectedVariantId) {
//         const variant = product.variants.find(v => v.id == selectedVariantId);
//         unitPrice = variant ? variant.price : (product.variants[0]?.price || 0);
//       } else {
//         unitPrice = product.variants[0]?.price || 0;
//       }

//       const qty = getSelectedQuantity();
//       console.log(`🎁 Gift check — Unit: ${unitPrice/100} PKR × Qty: ${qty} = Total: ${(unitPrice * qty)/100} PKR`);
//       return unitPrice * qty;
//     } catch {
//       return 0;
//     }
//   }

//   // Selected variant ID lena
//   function getSelectedVariantId() {
//     const urlParams = new URLSearchParams(window.location.search);
//     if (urlParams.get('variant')) return urlParams.get('variant');

//     const variantInput = document.querySelector(
//       'input[name="id"], select[name="id"], [name="id"]'
//     );
//     if (variantInput?.value) return variantInput.value;

//     if (window.ShopifyAnalytics?.meta?.selectedVariantId) {
//       return window.ShopifyAnalytics.meta.selectedVariantId;
//     }

//     return null;
//   }

//   // ✅ Cart mein qty ke saath add karna
//   async function addBothToCart(mainVariantId, giftVariantId, giftTier) {
//     const cart = await fetch('/cart.js').then(r => r.json());

//     // Purana gift remove karo
//     for (const item of cart.items) {
//       if (item.properties && item.properties._free_gift === 'true') {
//         await removeGift(item);
//       }
//     }

//     const qty = getSelectedQuantity();

//     await fetch('/cart/add.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({
//         items: [
//           {
//             id: mainVariantId,
//             quantity: qty ,
//             properties: null  // ✅ Actual quantity
//           },
//           {
//             id: giftVariantId,
//             quantity: 1,
//             properties: { _free_gift: 'true', _gift_tier: giftTier }
//           }
//         ]
//       })
//     });

//     localStorage.setItem('giftTier', giftTier);
//     updateGiftUI(giftTier);
//     window.location.href = '/checkout';
//   }

//   // Popup dikhana
//   async function showBuyItNowGiftPopup(mainVariantId) {
//     const price = await getCurrentProductPrice();
//     const tierObj = TIERS.find(t => price >= t.min && price < t.max);

//     if (!tierObj) {
//       // Koi tier nahi — bina gift checkout
//       const qty = getSelectedQuantity();
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: mainVariantId, quantity: qty })
//       });
//       window.location.href = '/checkout';
//       return;
//     }

//     document.querySelectorAll('.global-free-gift-popup').forEach(p => p.style.display = 'none');
//     const popup = document.getElementById(tierObj.popup);

//     if (!popup) {
//       const qty = getSelectedQuantity();
//       await fetch('/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({ id: mainVariantId, quantity: qty })
//       });
//       window.location.href = '/checkout';
//       return;
//     }

//     popup.style.display = 'block';
//     bindBuyItNowGiftButtons(popup, mainVariantId, tierObj.tier);
//   }

//   // Gift buttons bind karna (Buy It Now mode)
//   function bindBuyItNowGiftButtons(scope, mainVariantId, giftTier) {
//     scope.querySelectorAll('.add-global-free-gift').forEach(btn => {
//       const newBtn = btn.cloneNode(true);
//       btn.parentNode.replaceChild(newBtn, btn);

//       newBtn.onclick = async (e) => {
//         e.preventDefault();
//         const giftVariantId = newBtn.dataset.variantId;

//         newBtn.innerText = 'Adding...';
//         newBtn.disabled = true;

//         try {
//           await addBothToCart(mainVariantId, giftVariantId, giftTier);
//         } catch (err) {
//           console.error('Buy It Now gift error:', err);
//           newBtn.innerText = 'Select Gift';
//           newBtn.disabled = false;
//         }
//       };
//     });

//     scope.querySelectorAll('.skip-gift-btn, [data-skip-gift]').forEach(btn => {
//       btn.onclick = async (e) => {
//         e.preventDefault();
//         const qty = getSelectedQuantity();
//         await fetch('/cart/add.js', {
//           method: 'POST',
//           headers: { 'Content-Type': 'application/json' },
//           body: JSON.stringify({ id: mainVariantId, quantity: qty })
//         });
//         window.location.href = '/checkout';
//       };
//     });
//   }

//   // Buy It Now intercept
//   function interceptBuyItNowButtons() {
//     if (!window.location.pathname.includes('/products/')) return;

//     const selectors = [
//       '[name="checkout"]',
//       '.shopify-payment-button__button',
//       '.shopify-payment-button button',
//       '[data-testid="Checkout-button"]',
//       '#buy-it-now',
//       '.buy-it-now',
//       '[data-action="buy-now"]'
//     ];

//     document.querySelectorAll(selectors.join(', ')).forEach(btn => {
//       if (btn.dataset.giftIntercepted) return;
//       btn.dataset.giftIntercepted = 'true';

//       btn.addEventListener('click', async (e) => {
//         // ✅ Synchronous — pehle rok do
//         e.preventDefault();
//         e.stopImmediatePropagation();
//         e.stopPropagation();

//         const variantId = getSelectedVariantId();
//         if (!variantId) {
//           window.location.href = '/checkout';
//           return;
//         }

//         await showBuyItNowGiftPopup(variantId);
//       }, true);
//     });
//   }

//   function watchForBuyItNowButtons() {
//     const observer = new MutationObserver(() => {
//       interceptBuyItNowButtons();
//     });
//     observer.observe(document.body, { childList: true, subtree: true });
//   }

//   // =====================================================
//   // EXISTING CODE
//   // =====================================================

//   function getFreeGiftTotal(cart) {
//     return cart.items.reduce((sum, item) => {
//       if (item.properties && item.properties._free_gift === 'true') {
//         return sum + (item.final_line_price || 0);
//       }
//       return sum;
//     }, 0);
//   }

//   // function updateCartUI(cart) {
//   //   const freeGiftTotal = getFreeGiftTotal(cart);
//   //   const adjustedTotal = cart.total_price - freeGiftTotal;

//   //   const tryUpdate = () => {
//   //     // const subtotalEl = document.querySelector('[data-cart-subtotal]');
//   //     // const totalEl = document.querySelector('[data-cart-total-value]');

//   //     if (subtotalEl) subtotalEl.innerText = 'PKR ' + (cart.original_total_price / 100).toLocaleString('en-PK');
//   //     if (totalEl) totalEl.innerText = 'PKR ' + (adjustedTotal / 100).toLocaleString('en-PK');

//   //     return !!(subtotalEl && totalEl);
//   //   };

//   //   let attempts = 0;
//   //   const interval = setInterval(() => {
//   //     if (tryUpdate() || attempts++ > 15) clearInterval(interval);
//   //   }, 250);
//   // }

//   function updateGiftUI(tier) {
//     if (!tier) return;
//     if (lastTier === tier) return;
//     lastTier = tier;

//     let attempts = 0;
//     const maxAttempts = 25;

//     const applyToAll = () => {
//       const elements = document.querySelectorAll('.gift-li');

//       if (elements.length === 0) {
//         if (attempts < maxAttempts) {
//           attempts++;
//           setTimeout(applyToAll, 180);
//         }
//         return;
//       }

//       elements.forEach((el, index) => {
//         el.classList.remove('gift-body_mist', 'gift-30ml', 'gift-50ml', 'gift-100ml', 'gift-active');
//         el.setAttribute('data-gift', tier);
//         el.classList.add('gift-active', `gift-${tier}`);
//         console.log(`✅ Gift UI Applied to element ${index + 1}: ${tier}`);
//       });
//     };

//     applyToAll();
//     setTimeout(applyToAll, 300);
//     setTimeout(applyToAll, 800);
//     setTimeout(applyToAll, 1500);
//   }

//   async function getTags(handle) {
//     try {
//       const res = await fetch(`/products/${handle}.js`);
//       const product = await res.json();
//       return product.tags || [];
//     } catch {
//       return [];
//     }
//   }

//   async function removeGift(item) {
//     if (!item) return;
//     return fetch('/cart/change.js', {
//       method: 'POST',
//       headers: { 'Content-Type': 'application/json' },
//       body: JSON.stringify({ id: item.key, quantity: 0 })
//     });
//   }

//   function openPopup(popupId) {
//     if (popupTimeout) clearTimeout(popupTimeout);
//     popupTimeout = setTimeout(() => {
//       document.querySelectorAll('.global-free-gift-popup').forEach(p => p.style.display = 'none');
//       const popup = document.getElementById(popupId);
//       if (popup) {
//         popup.style.display = 'block';
//         bindGiftButtons(popup);
//       }
//     }, 400);
//   }

//   function bindGiftButtons(scope = document) {
//     scope.querySelectorAll('.add-global-free-gift').forEach(btn => {
//       btn.onclick = null;
//       btn.onclick = async (e) => {
//         e.preventDefault();
//         const variantId = btn.dataset.variantId;
//         const tier = btn.dataset.giftTier;

//         btn.innerText = 'Adding...';
//         btn.disabled = true;

//         try {
//           const cart = await fetch('/cart.js').then(r => r.json());
//           for (const item of cart.items) {
//             if (item.properties && item.properties._free_gift === 'true') {
//               await removeGift(item);
//             }
//           }

//           await fetch('/cart/add.js', {
//             method: 'POST',
//             headers: { 'Content-Type': 'application/json' },
//             body: JSON.stringify({
//               id: variantId,
//               quantity: 1,
//               properties: { _free_gift: 'true', _gift_tier: tier }
//             })
//           });

//           localStorage.setItem('giftTier', tier);
//           updateGiftUI(tier);
//           window.location.reload();
//         } catch (err) {
//           console.error('Gift add error:', err);
//           btn.innerText = 'Select Gift';
//           btn.disabled = false;
//         }
//       };
//     });
//   }

//  async function validateGift() {
//     if (running) return;
//     running = true;

//     try {
//         const cart = await fetch('/cart.js').then(r => r.json());
        
//         let total = 0;
//         let currentGift = null;

//         console.clear(); // Clean console
//         console.log('=== GIFT VALIDATION START ===');
//         console.log('Cart Total Items:', cart.items.length);

//         for (const item of cart.items) {
//             if (item.properties && item.properties._free_gift === 'true') {
//                 currentGift = item;
//                 console.log(`⏭️  Skipped Free Gift: ${item.title}`);
//                 continue;
//             }

//             const lineTotal = item.final_line_price || 0;
//             const handle = item.handle || 'NO-HANDLE';

//             console.log(`📦 Item: ${item.title} | Qty: ${item.quantity} | Line Total: ${lineTotal/100} PKR | Handle: ${handle}`);

//             // Direct total add karo (temporary bypass for debugging)
//             total += lineTotal;
//             console.log(`   ✅ Added ${lineTotal/100} to total`);

//             // Tags check (sirf dekhne ke liye)
//             if (handle !== 'NO-HANDLE') {
//                 const tags = await getTags(handle);
//                 console.log(`   Tags: ${tags.length ? tags.join(', ') : 'No tags found'}`);
//             }
//         }

//         console.log('🎯 FINAL CALCULATED TOTAL:', (total / 100).toLocaleString('en-PK'), 'PKR');

//         const tierObj = TIERS.find(t => total >= t.min && total < t.max);
//         console.log('🏷️  Tier Detected:', tierObj ? tierObj.tier : 'NO TIER');

//         if (tierObj) {
//             updateGiftUI(tierObj.tier);

//             if (!currentGift) {
//                 console.log(`🚀 Opening popup for ${tierObj.tier}`);
//                 openPopup(tierObj.popup);
//             } else if (currentGift.properties._gift_tier !== tierObj.tier) {
//                 console.log('🔄 Gift tier changed, removing old gift...');
//                 await removeGift(currentGift);
//                 openPopup(tierObj.popup);
//             }
//         } else if (currentGift) {
//             console.log('🗑️ Removing gift - total below threshold');
//             await removeGift(currentGift);
//         }

//     } catch (e) {
//         console.error('❌ Gift manager error:', e);
//     } finally {
//         setTimeout(() => { running = false; }, 1200);
//     }
// }

//   function startMutationObserver() {
//     if (uiObserver) uiObserver.disconnect();

//     uiObserver = new MutationObserver(() => {
//       if (lastTier && document.querySelector('.gift-li')) {
//         setTimeout(() => updateGiftUI(lastTier), 400);
//       }
//     });

//     uiObserver.observe(document.body, { childList: true, subtree: true });
//   }

//   async function initGiftManager() {
//     startMutationObserver();

//     const cart = await fetch('/cart.js').then(r => r.json());
//     // updateCartUI(cart);

//     const savedTier = localStorage.getItem('giftTier');
//     if (savedTier) {
//       updateGiftUI(savedTier);
//       localStorage.removeItem('giftTier');
//     }

//     interceptBuyItNowButtons();
//     watchForBuyItNowButtons();

//     setTimeout(validateGift, 600);
//     setTimeout(validateGift, 1400);
//     setTimeout(validateGift, 2400);
//   }

//   document.addEventListener('DOMContentLoaded', initGiftManager);
//   window.addEventListener('load', () => setTimeout(initGiftManager, 800));

//   // Fetch Hook
//   const originalFetch = window.fetch;
//   window.fetch = async function (...args) {
//     const res = await originalFetch.apply(this, args);
//     const url = String(args[0]);
//     if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
//       setTimeout(validateGift, 700);
//     }
//     return res;
//   };

//   // XHR Backup
//   const originalOpen = XMLHttpRequest.prototype.open;
//   XMLHttpRequest.prototype.open = function (method, url) {
//     this._giftUrl = url;
//     return originalOpen.apply(this, arguments);
//   };

//   const originalSend = XMLHttpRequest.prototype.send;
//   XMLHttpRequest.prototype.send = function () {
//     this.addEventListener('load', function () {
//       if (this._giftUrl && (
//         this._giftUrl.includes('/cart/add') ||
//         this._giftUrl.includes('/cart/change') ||
//         this._giftUrl.includes('/cart/update')
//       )) {
//         setTimeout(validateGift, 800);
//       }
//     });
//     return originalSend.apply(this, arguments);
//   };

// })();


console.log('Gift manager loaded (v6 - Quantity Fix):', window.location.pathname);

(function () {

  const TIERS = [
    { min: 400000, max: 600000, tier: 'body_mist', popup: 'body-mist-gifts' },
    { min: 600000, max: 800000, tier: '30ml', popup: 'gift-30ml' },
    { min: 800000, max: 1200000, tier: '50ml', popup: 'gift-50ml' },
    { min: 1200000, max: Infinity, tier: '100ml', popup: 'gift-100ml' }
  ];

  const APPAREL_TAGS = ['Free-apparel-gift', 'naturals'];
  const EXCLUDED_TAGS = [''];

  let running = false;
  let lastTier = null;
  let popupTimeout = null;
  let uiObserver = null;

  // =====================================================
  // BUY IT NOW INTERCEPTOR
  // =====================================================

  // ✅ Selected quantity lena
  function getSelectedQuantity() {
    const qtyInput = document.querySelector(
      'input[name="quantity"], .quantity__input, [data-quantity-input], #quantity, .qty__input, [data-cart-quantity]'
    );
    const qty = parseInt(qtyInput?.value || '1', 10);
    return isNaN(qty) || qty < 1 ? 1 : qty;
  }

  // ✅ Price × Quantity = total
  async function getCurrentProductPrice() {
    try {
      const handle = window.location.pathname.split('/products/')[1]?.split('?')[0];
      if (!handle) return 0;

      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();

      const selectedVariantId = getSelectedVariantId();
      let unitPrice = 0;

      if (selectedVariantId) {
        const variant = product.variants.find(v => v.id == selectedVariantId);
        unitPrice = variant ? variant.price : (product.variants[0]?.price || 0);
      } else {
        unitPrice = product.variants[0]?.price || 0;
      }

      const qty = getSelectedQuantity();
      console.log(`🎁 Gift check — Unit: ${unitPrice/100} PKR × Qty: ${qty} = Total: ${(unitPrice * qty)/100} PKR`);
      return unitPrice * qty;
    } catch {
      return 0;
    }
  }

  // Selected variant ID lena
  function getSelectedVariantId() {
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('variant')) return urlParams.get('variant');

    const variantInput = document.querySelector(
      'input[name="id"], select[name="id"], [name="id"]'
    );
    if (variantInput?.value) return variantInput.value;

    if (window.ShopifyAnalytics?.meta?.selectedVariantId) {
      return window.ShopifyAnalytics.meta.selectedVariantId;
    }

    return null;
  }

  // ✅ Cart mein qty ke saath add karna
  async function addBothToCart(mainVariantId, giftVariantId, giftTier) {
    const cart = await fetch('/cart.js').then(r => r.json());

    // Purana gift remove karo
    for (const item of cart.items) {
      if (item.properties && item.properties._free_gift === 'true') {
        await removeGift(item);
      }
    }

    const qty = getSelectedQuantity();

    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: mainVariantId,
            quantity: qty ,
            properties: null  // ✅ Actual quantity
          },
          {
            id: giftVariantId,
            quantity: 1,
            properties: { _free_gift: 'true', _gift_tier: giftTier }
          }
        ]
      })
    });
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          "Free Gift Product": "Yes"
        }
      })
    });


    localStorage.setItem('giftTier', giftTier);
    updateGiftUI(giftTier);
    window.location.href = '/checkout';
  }

  // Popup dikhana
  async function showBuyItNowGiftPopup(mainVariantId) {
    const price = await getCurrentProductPrice();
    const tierObj = TIERS.find(t => price >= t.min && price < t.max);

    if (!tierObj) {
      // Koi tier nahi — bina gift checkout
      const qty = getSelectedQuantity();
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: mainVariantId, quantity: qty })
      });
      window.location.href = '/checkout';
      return;
    }

    document.querySelectorAll('.global-free-gift-popup').forEach(p => p.style.display = 'none');
    const popup = document.getElementById(tierObj.popup);

    if (!popup) {
      const qty = getSelectedQuantity();
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: mainVariantId, quantity: qty })
      });
      window.location.href = '/checkout';
      return;
    }

    popup.style.display = 'block';
    bindBuyItNowGiftButtons(popup, mainVariantId, tierObj.tier);
  }

  // Gift buttons bind karna (Buy It Now mode)
  function bindBuyItNowGiftButtons(scope, mainVariantId, giftTier) {
    scope.querySelectorAll('.add-global-free-gift').forEach(btn => {
      const newBtn = btn.cloneNode(true);
      btn.parentNode.replaceChild(newBtn, btn);

      newBtn.onclick = async (e) => {
        e.preventDefault();
        const giftVariantId = newBtn.dataset.variantId;

        newBtn.innerText = 'Adding...';
        newBtn.disabled = true;

        try {
          await addBothToCart(mainVariantId, giftVariantId, giftTier);
        } catch (err) {
          console.error('Buy It Now gift error:', err);
          newBtn.innerText = 'Select Gift';
          newBtn.disabled = false;
        }
      };
    });

    scope.querySelectorAll('.skip-gift-btn, [data-skip-gift]').forEach(btn => {
      btn.onclick = async (e) => {
        e.preventDefault();
        const qty = getSelectedQuantity();
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: mainVariantId, quantity: qty })
        });
        window.location.href = '/checkout';
      };
    });
  }

  // Buy It Now intercept
  function interceptBuyItNowButtons() {
    if (!window.location.pathname.includes('/products/')) return;

    const selectors = [
      '[name="checkout"]',
      '.shopify-payment-button__button',
      '.shopify-payment-button button',
      '[data-testid="Checkout-button"]',
      '#buy-it-now',
      '.buy-it-now',
      '[data-action="buy-now"]'
    ];

    document.querySelectorAll(selectors.join(', ')).forEach(btn => {
      if (btn.dataset.giftIntercepted) return;
      btn.dataset.giftIntercepted = 'true';

      btn.addEventListener('click', async (e) => {
        // ✅ Synchronous — pehle rok do
        e.preventDefault();
        e.stopImmediatePropagation();
        e.stopPropagation();

        const variantId = getSelectedVariantId();
        if (!variantId) {
          window.location.href = '/checkout';
          return;
        }

        await showBuyItNowGiftPopup(variantId);
      }, true);
    });
  }

  function watchForBuyItNowButtons() {
    const observer = new MutationObserver(() => {
      interceptBuyItNowButtons();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  // =====================================================
  // EXISTING CODE
  // =====================================================

  function getFreeGiftTotal(cart) {
    return cart.items.reduce((sum, item) => {
      if (item.properties && item.properties._free_gift === 'true') {
        return sum + (item.final_line_price || 0);
      }
      return sum;
    }, 0);
  }

  // function updateCartUI(cart) {
  //   const freeGiftTotal = getFreeGiftTotal(cart);
  //   const adjustedTotal = cart.total_price - freeGiftTotal;

  //   const tryUpdate = () => {
  //     // const subtotalEl = document.querySelector('[data-cart-subtotal]');
  //     // const totalEl = document.querySelector('[data-cart-total-value]');

  //     if (subtotalEl) subtotalEl.innerText = 'PKR ' + (cart.original_total_price / 100).toLocaleString('en-PK');
  //     if (totalEl) totalEl.innerText = 'PKR ' + (adjustedTotal / 100).toLocaleString('en-PK');

  //     return !!(subtotalEl && totalEl);
  //   };

  //   let attempts = 0;
  //   const interval = setInterval(() => {
  //     if (tryUpdate() || attempts++ > 15) clearInterval(interval);
  //   }, 250);
  // }

  function updateGiftUI(tier) {
    if (!tier) return;
    if (lastTier === tier) return;
    lastTier = tier;

    let attempts = 0;
    const maxAttempts = 25;

    const applyToAll = () => {
      const elements = document.querySelectorAll('.gift-li');

      if (elements.length === 0) {
        if (attempts < maxAttempts) {
          attempts++;
          setTimeout(applyToAll, 180);
        }
        return;
      }

      elements.forEach((el, index) => {
        el.classList.remove('gift-body_mist', 'gift-30ml', 'gift-50ml', 'gift-100ml', 'gift-active');
        el.setAttribute('data-gift', tier);
        el.classList.add('gift-active', `gift-${tier}`);
        console.log(`✅ Gift UI Applied to element ${index + 1}: ${tier}`);
      });
    };

    applyToAll();
    setTimeout(applyToAll, 300);
    setTimeout(applyToAll, 800);
    setTimeout(applyToAll, 1500);
  }

  async function getTags(handle) {
    try {
      const res = await fetch(`/products/${handle}.js`);
      const product = await res.json();
      return product.tags || [];
    } catch {
      return [];
    }
  }

  async function removeGift(item) {
  if (!item) return;

  // Gift remove
  await fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      id: item.key,
      quantity: 0
    })
  });

  // Cart attribute clear
  await fetch('/cart/update.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      attributes: {
        "Free Gift Product": "true"
      }
    })
  });
}

  function openPopup(popupId) {
    if (popupTimeout) clearTimeout(popupTimeout);
    popupTimeout = setTimeout(() => {
      document.querySelectorAll('.global-free-gift-popup').forEach(p => p.style.display = 'none');
      const popup = document.getElementById(popupId);
      if (popup) {
        popup.style.display = 'block';
        bindGiftButtons(popup);
      }
    }, 400);
  }

  function bindGiftButtons(scope = document) {
    scope.querySelectorAll('.add-global-free-gift').forEach(btn => {
      btn.onclick = null;
      btn.onclick = async (e) => {
        e.preventDefault();
        const variantId = btn.dataset.variantId;
        const tier = btn.dataset.giftTier;

        btn.innerText = 'Adding...';
        btn.disabled = true;

        try {
          const cart = await fetch('/cart.js').then(r => r.json());
          for (const item of cart.items) {
            if (item.properties && item.properties._free_gift === 'true') {
              await removeGift(item);
            }
          }

         await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: variantId,
              quantity: 1,
              properties: {
                _free_gift: 'true',
                _gift_tier: tier
              }
            })
          });

          await fetch('/cart/update.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              attributes: {
                "Free Gift Product": "true"
              }
            })
          });

          localStorage.setItem('giftTier', tier);
          updateGiftUI(tier);
          window.location.reload();
        } catch (err) {
          console.error('Gift add error:', err);
          btn.innerText = 'Select Gift';
          btn.disabled = false;
        }
      };
    });
  }

 async function validateGift() {
    if (running) return;
    running = true;

    try {
        const cart = await fetch('/cart.js').then(r => r.json());
        
        let total = 0;
        let currentGift = null;

        console.clear(); // Clean console
        console.log('=== GIFT VALIDATION START ===');
        console.log('Cart Total Items:', cart.items.length);

        for (const item of cart.items) {
            if (item.properties && item.properties._free_gift === 'true') {
                currentGift = item;
                console.log(`⏭️  Skipped Free Gift: ${item.title}`);
                continue;
            }

            const lineTotal = item.final_line_price || 0;
            const handle = item.handle || 'NO-HANDLE';

            console.log(`📦 Item: ${item.title} | Qty: ${item.quantity} | Line Total: ${lineTotal/100} PKR | Handle: ${handle}`);

            // Direct total add karo (temporary bypass for debugging)
            total += lineTotal;
            console.log(`   ✅ Added ${lineTotal/100} to total`);

            // Tags check (sirf dekhne ke liye)
            if (handle !== 'NO-HANDLE') {
                const tags = await getTags(handle);
                console.log(`   Tags: ${tags.length ? tags.join(', ') : 'No tags found'}`);
            }
        }

        console.log('🎯 FINAL CALCULATED TOTAL:', (total / 100).toLocaleString('en-PK'), 'PKR');

        const tierObj = TIERS.find(t => total >= t.min && total < t.max);
        console.log('🏷️  Tier Detected:', tierObj ? tierObj.tier : 'NO TIER');

        if (tierObj) {
            updateGiftUI(tierObj.tier);

            if (!currentGift) {
                console.log(`🚀 Opening popup for ${tierObj.tier}`);
                openPopup(tierObj.popup);
            } else if (currentGift.properties._gift_tier !== tierObj.tier) {
                console.log('🔄 Gift tier changed, removing old gift...');
                await removeGift(currentGift);
                openPopup(tierObj.popup);
            }
        } else if (currentGift) {
            console.log('🗑️ Removing gift - total below threshold');
            await removeGift(currentGift);
        }

    } catch (e) {
        console.error('❌ Gift manager error:', e);
    } finally {
        setTimeout(() => { running = false; }, 1200);
    }
}

  function startMutationObserver() {
    if (uiObserver) uiObserver.disconnect();

    uiObserver = new MutationObserver(() => {
      if (lastTier && document.querySelector('.gift-li')) {
        setTimeout(() => updateGiftUI(lastTier), 400);
      }
    });

    uiObserver.observe(document.body, { childList: true, subtree: true });
  }

  async function initGiftManager() {
    startMutationObserver();

    const cart = await fetch('/cart.js').then(r => r.json());
    // updateCartUI(cart);

    const savedTier = localStorage.getItem('giftTier');
    if (savedTier) {
      updateGiftUI(savedTier);
      localStorage.removeItem('giftTier');
    }

    interceptBuyItNowButtons();
    watchForBuyItNowButtons();

    setTimeout(validateGift, 600);
    setTimeout(validateGift, 1400);
    setTimeout(validateGift, 2400);
  }

  document.addEventListener('DOMContentLoaded', initGiftManager);
  window.addEventListener('load', () => setTimeout(initGiftManager, 800));

  // Fetch Hook
  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const res = await originalFetch.apply(this, args);
    const url = String(args[0]);
    if (url.includes('/cart/add') || url.includes('/cart/change') || url.includes('/cart/update')) {
      setTimeout(validateGift, 700);
    }
    return res;
  };

  // XHR Backup
  const originalOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    this._giftUrl = url;
    return originalOpen.apply(this, arguments);
  };

  const originalSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    this.addEventListener('load', function () {
      if (this._giftUrl && (
        this._giftUrl.includes('/cart/add') ||
        this._giftUrl.includes('/cart/change') ||
        this._giftUrl.includes('/cart/update')
      )) {
        setTimeout(validateGift, 800);
      }
    });
    return originalSend.apply(this, arguments);
  };

})();